var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map_container"}},[_c('el-amap',{staticClass:"amap_demo",attrs:{"center":_vm.center,"zoom":_vm.zoom,"plugin":_vm.plugin}},_vm._l((_vm.markers),function(marker,index){return _c('el-amap-marker',{key:index,attrs:{"position":marker.position}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8868a4c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivateComponent/map.vue
// module id = null
// module chunks = 